// 从 axios 错误里取出**最具体**的可读信息。
//
// 后端的错误响应有三种形状，只读其中一种就会把真因吞掉：
//   - 校验失败：{ error: '数据验证失败', details: [{ msg }] }   ← 没有 message
//   - 业务错误：{ error: '验证码无效', message: '验证码错误或已过期' }
//   - 简单错误：{ error: '...' }
// 密码重置的 bug 就被这点掩盖过：前端漏传 code 被 validator 挡下返回 400 {error, details}，
// 而处理器只读 `data.message` → 恒为空 → 一律显示兜底的「重置失败，请重试」，
// 真正的原因「验证码为6位数字」从未露出来，问题因此更难被发现。
//
// 多语言（docs/I18N.md 第五节）：界面是中文 → 原样用后端文案（中文是事实源、带具体参数）；
// 界面是其他语言且后端没按该语言翻译（响应无 locale 或不同）→ 有 errors:<code> 就用它兜底，否则仍显示后端原文。
import i18n from '../i18n';

function localizedByCode(data) {
  const lng = i18n.language || 'zh-CN';
  if (lng.startsWith('zh') || !data.code || data.locale === lng) return null;
  const key = `errors:${data.code}`;
  return i18n.exists(key) ? i18n.t(key) : null;
}

export function apiError(error, fallback = i18n.t('common:toast.failed')) {
  const data = error?.response?.data;
  if (!data) return fallback;
  const byCode = localizedByCode(data);
  if (byCode) return byCode;

  if (Array.isArray(data.details) && data.details.length > 0) {
    const msgs = data.details.map((d) => d?.msg).filter(Boolean);
    if (msgs.length > 0) return msgs.join('，');
  }
  return data.message || data.error || fallback;
}

export default apiError;
